import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import TicketackUsersList from './TicketackUsersList/TicketackUsersList';
import TicketackUserEdit from './TicketackUserEdit/TicketackUserEdit';
import TicketackUserCreate from './TicketackUserCreate/TicketackUserCreate';
import TicketackUserDelete from './TicketackUserDelete/TicketackUserDelete';

const TicketackUsers = ({ match }) => {
    return (
        <div className="TicketackUsers">
            <ContainerWrapper container="tktusers">
                <Route exact path={match.path} component={TicketackUsersList} />
                <Route exact path={`${match.url}/edit/:userId/`} component={TicketackUserEdit} />
                <Route exact path={ `${ match.url }/delete/:userId` } component={TicketackUserDelete} />
                <Route exact path={`${match.url}/new/:mode`} component={TicketackUserCreate} />
            </ContainerWrapper>
        </div>
    );
}

export default TicketackUsers;
